import React, { useCallback, useEffect, useState } from "react";

import { ReskinningAutocomplete } from "../ReskinningAutocomplete";
import { useDebouncedAction } from "../../../Hooks/DebouncedAction";

function CustomAsyncAutocomplete(props) {
  const {
    idRef = "",
    multiple = false,
    required,
    wrapperClasses,
    labelValue,
    disabled,
    className = "",
    filterSelectedOptions,
    isSubmitted,
    withError,
    error,
    helperText,
    placeholder,
    inputClasses,
    filterOptions,
    disableClearable,
    rootCustomClasses,
    autocompleteClasses,
    onChange,
    filter,
    selectedValues,
    onFetchData,
    mapper,
    refetchOnSearch,
    queryKey,
    getOptionSelected,
    chipsLabel,
    displayLabel,
    renderOption,
    forceError,
    inputStartAdornment,
    popoverClasses,
  } = props;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchFilter, setSearchFilter] = useState(filter);
  const getData = useCallback(async () => {
    if (disabled) return;
    setIsLoading(true);
    const res = await onFetchData(searchFilter);
    if (!(res && res.status && res.status !== 200)) {
      let mapped = [];
      if (!res.result) {
        mapped = mapper(res);
      } else {
        mapped = mapper(res.result);
      }
      setData(mapped || []);
    }
    setIsLoading(false);
  }, [searchFilter, disabled]);

  const searchHandler = useDebouncedAction(
    async (value) => {
      if (refetchOnSearch && value) {
        setSearchFilter((f) => ({ ...f, [queryKey]: value }));
      }
    },
    { delay: 700 }
  );

  useEffect(() => {
    if (!disabled && filter) getData();
  }, [searchFilter, disabled]);

  return (
    <div className={className}>
      <ReskinningAutocomplete
        data={data}
        autocompleteClasses={autocompleteClasses}
        filterSelectedOptions={filterSelectedOptions}
        filterOptions={filterOptions}
        inputPlaceholder={placeholder}
        isSubmitted={isSubmitted}
        isWithError={withError}
        selectedValues={selectedValues}
        labelClasses={required ? "Requierd-Color" : ""}
        labelValue={labelValue}
        multiple={multiple}
        error={error}
        helperText={helperText}
        displayLabel={displayLabel}
        renderOption={renderOption}
        chipsLabel={chipsLabel}
        getOptionSelected={getOptionSelected}
        isLoading={isLoading}
        onChange={onChange}
        inputWrapperClasses={wrapperClasses}
        withoutSearchButton
        isDisabled={disabled}
        inputClasses={inputClasses}
        disableClearable={disableClearable}
        rootCustomClasses={rootCustomClasses}
        onInputKeyUp={(e) => {
          if (e?.target?.value) searchHandler(e?.target?.value);
        }}
        idRef={idRef}
        forceError={forceError}
        inputStartAdornment={inputStartAdornment}
        enableTextTruncate
        popoverClasses={popoverClasses}
      />
    </div>
  );
}

export default CustomAsyncAutocomplete;
